export { GET_TIM_QUERY, SEARCH_TIMS_QUERY } from './queries';

export { DELETE_TIM_MUTATION, UPDATE_TIM_MUTATION } from './mutations';
